export const AnalyticsEvents = {
  auth: {
    sign_up: 'sign_up',
  },
  billing: {
    trialStarted: 'billing.trial_started',
    trialUpsellDialogOpened: 'billing.trial_upsell_dialog_opened',
    trialExpiredDialogOpened: 'billing.trial_expired_dialog_opened',
    planSwitched: 'billing.plan_switched',
    portalOpened: 'billing.portal_opened',
    basePlanChosen: 'billing.base_plan_chosen',
    trialExtensionAccepted: 'billing.trial_extension_accepted',
    trialExtensionDeclined: 'billing.trial_extension_declined',
  },
  checkout: {
    dialogOpen: 'checkout.dialog.open',
    dialogClose: 'checkout.dialog.close',
    submit: 'checkout.submit',
    success: 'checkout.success',
    canceled: 'checkout.canceled',
    onboardingSkipped: 'checkout.onboarding_skipped',
    purchase: 'purchase',
  },
  checkoutOffer: {
    onboardingPlanSelectionImp: 'onboarding_plan_selection_imp',
    onboardingPlanSelectionT2p: 'onboarding_plan_selection_t2p',
    onboardingExpressCheckoutImp: 'onboarding_express_checkout_imp',
    onboardingExpressCheckoutT2p: 'onboarding_express_checkout_t2p',
    trialUpgradeButtonImp: 'trial_upgrade_btn_imp',
    trialUpgradeButtonT2p: 'trial_upgrade_btn_t2p',
    basisUpgradeButtonImp: 'basis_upgrade_btn_imp',
    basisUpgradeButtonF2p: 'basis_upgrade_btn_f2p',
    trialAdminPlansImp: 'trial_admin_plans_imp',
    trialAdminPlansT2p: 'trial_admin_plans_t2p',
    basisAdminPlansImp: 'basis_admin_plans_imp',
    basisAdminPlansF2p: 'basis_admin_plans_f2p',
    trialIntermittentImp: 'trial_intermittent_imp',
    trialIntermittentT2p: 'trial_intermittent_t2p',
    basisIntermittentImp: 'basis_intermittent_imp',
    basisIntermittentF2p: 'basis_intermittent_f2p',
    trialDiscountButtonImp: 'trial_discount_btn_imp',
    trialDiscountButtonT2p: 'trial_discount_btn_t2p',
    trialFeedbackImp: 'trial_feedback_imp',
    trialFeedbackT2p: 'trial_feedback_t2p',
    trialFeedbackT2f: 'trial_feedback_t2f',
    basisFeatureLockImp: 'basis_feature_lock_imp',
    basisFeatureLockF2p: 'basis_feature_lock_f2p',
    basisFeatureLockStatisticImp: 'basis_feature_lock_statistic_imp',
    basisFeatureLockStatisticF2p: 'basis_feature_lock_statistic_f2p',
    basisFeatureLockReportImp: 'basis_feature_lock_report_imp',
    basisFeatureLockReportF2p: 'basis_feature_lock_report_f2p',
    basisFeatureLockCollaborationImp: 'basis_feature_lock_collaboration_imp',
    basisFeatureLockCollaborationF2p: 'basis_feature_lock_collaboration_f2p',
    basisFeatureLockTenantCustomizationImp: 'basis_lock_tenant_customization_imp',
    basisFeatureLockTenantCustomizationF2p: 'basis_lock_tenant_customization_f2p',
    basisFeatureLockGradeCustomizationImp: 'basis_lock_grade_customization_imp',
    basisFeatureLockGradeCustomizationF2p: 'basis_lock_grade_customization_f2p',
    basisFeatureLockAccessRightsImp: 'basis_feature_lock_access_rights_imp',
    basisFeatureLockAccessRightsF2p: 'basis_feature_lock_access_rights_f2p',
    basisFeatureLockUnknownImp: 'basis_feature_lock_unknown_imp',
    basisFeatureLockUnknownF2p: 'basis_feature_lock_unknown_f2p',
  },
  funnelSummary: {
    registered: 'sum_registered',
    r2t: 'sum_r2t',
    t2p: 'sum_t2p',
    t2f: 'sum_t2f',
    f2p: 'sum_f2p',
  },
  performanceAssessment: {
    entryCreated: 'performance_assessment.entry_created',
    entryUpdated: 'performance_assessment.entry_updated',
    entryDeleted: 'performance_assessment.entry_deleted',
    entryDuplicated: 'performance_assessment.entry_duplicated',
  },
  note: {
    entryCreated: 'note.entry_created',
    entryUpdated: 'note.entry_updated',
    entryDeleted: 'note.entry_deleted',
  },
  supportMeasure: {
    entryCreated: 'support_measure.entry_created',
    entryUpdated: 'support_measure.entry_updated',
    entryCompleted: 'support_measure.entry_completed',
    entryDeleted: 'support_measure.entry_deleted',
    competencesAdded: 'support_measure.competences_added',
    competenceRemoved: 'support_measure.competence_removed',
    studentsAdded: 'support_measure.students_added',
    studentRemoved: 'support_measure.student_removed',
    protocolEntryCreated: 'support_measure.protocol_entry_created',
    protocolEntryUpdated: 'support_measure.protocol_entry_updated',
    protocolEntryDeleted: 'support_measure.protocol_entry_deleted',
  },
  growth: {
    firstEntryCompleted: 'growth.first_entry_completed',
  },
  referral: {
    attributed: 'referral.code.attributed',
    dialogOpen: 'referral.dialog.open',
    linkCopied: 'referral.link.copied',
    linkOpened: 'referral.link.opened',
    linkSend: 'referral.link.send',
    imp: 'referral_imp',
    shared: 'referral_shared',
  },
  rating: {
    dialogOpen: 'rating.dialog.open',
    starSubmitted: 'rating.star.submitted',
    feedbackOpened: 'rating.feedback.opened',
    feedbackSubmitted: 'rating.feedback.submitted',
    googleReviewOpened: 'rating.google_review.opened',
    imp: 'rating_imp',
    submitted: 'rating_submitted',
  },
  waitingRoom: {
    requestClassClicked: 'waiting_room.request_class_clicked',
  },
  report: {
    bulkCreated: 'report.bulk_created',
    singleCreated: 'report.single_created',
    updated: 'report.updated',
    closed: 'report.closed',
    deleted: 'report.deleted',
    printed: 'report.printed',
    downloaded: 'report.downloaded',
  },
  schoolClass: {
    created: 'school_class.created',
  },
  team: {
    membersInvited: 'team.members_invited',
    inviteLinkCopied: 'team.invite_link_copied',
  },
  onboarding: {
    setupChecklistCompleted: 'onboarding.setup_checklist_completed',
    userStepViewed: 'onboarding.user_step_viewed',
    userProfileCompleted: 'onboarding.user_profile_completed',
    acquisitionSourceCompleted: 'onboarding.acquisition_source_completed',
    acquisitionSourceSkipped: 'onboarding.acquisition_source_skipped',
    demoClassWizardCompleted: 'onboarding.demo_class_wizard_completed',
    schoolStepViewed: 'onboarding.school_step_viewed',
    schoolModeSelected: 'onboarding.school_mode_selected',
    schoolCreated: 'onboarding.school_created',
    schoolJoined: 'onboarding.school_joined',
    administrationSetupViewed: 'onboarding.administration_setup_viewed',
    administrationSetupCompleted: 'onboarding.admin_setup_completed',
  },
} as const;

export type AnalyticsEventName = {
  [Group in keyof typeof AnalyticsEvents]: (typeof AnalyticsEvents)[Group][keyof (typeof AnalyticsEvents)[Group]];
}[keyof typeof AnalyticsEvents];
